import React from 'react';
import { Link } from 'carbon-components-react';
import urlRegex from 'url-regex';

const TextWithLinks: React.FC<Props> = ({ text, className }) => {
  const convertURLsToLinks = (text?: string) => {
    if (!text) {
      return null;
    }

    const parts = text.split(urlRegex({ strict: false }));
    const links = text.match(urlRegex({ strict: false }));

    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {index > 0 && links && links[index - 1] ? (
          <Link
            href={
              links[index - 1].startsWith('http')
                ? links[index - 1]
                : `http://${links[index - 1]}`
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {links[index - 1]}
          </Link>
        ) : null}
        {part}
      </React.Fragment>
    ));
  };

  return <div className={className}>{convertURLsToLinks(text)}</div>;
};

type Props = {
  className?: string;
  text?: string;
};

export default React.memo(TextWithLinks);
